(function () {
'use strict';

angular.module('hyresgastApp').controller('ShowNegotiationOverviewCtrl', ShowNegotiationOverviewCtrl);

function ShowNegotiationOverviewCtrl(
  $scope, $location, $routeParams, $timeout, $document,
  Negotiation,
  Auth, HyUtils, ExportUtils,
  FeatureConfiguration, NegotiationStates, NegotiationTypes, Parties, Limits, CommonIds) {
  var vm = this;
  vm.parentCtrl = $scope.$parent.vm;

  vm.NegotiationStates = NegotiationStates;
  vm.Parties = Parties;
  vm.Limits = Limits;
  vm.FeatureConfiguration = FeatureConfiguration;

  vm.edit = edit;
  vm.editDelegates = editDelegates;
  vm.editNegotiation = editNegotiation;
  vm.moveItems = moveItems;
  vm.recallItems = recallItems;
  vm.gotoProperty = gotoProperty;

  vm.agreementStatuses = [
    { id: 0, name: 'Kvar att förhandla' },
    { id: 1, name: 'Pågående FÖK' },
    { id: 2, name: 'Överens' },
  ];

  vm.selectedRows = [];
  vm.pageLimit = 15;
  vm.pageOffset = 0;
  vm.attributesProperties = [
    {
      fn: row => row.agreementStatus === 2,
      legend: vm.agreementStatuses[2].name,
      class: 'table__tr--slime table__tr--border-reset',
      disabled: true,
    },
    {
      fn: row => row.agreementStatus === 1,
      legend: vm.agreementStatuses[1].name,
      class: 'table__tr--grey table__tr--border-reset',
      disabled: true,
    },
    {
      fn: row => !row.active,
      legend: 'Inaktiv',
      class: 'table__tr--inactive',
    },
  ];
  vm.actionsProperties = [
    {
      title: 'Lägg till',
      common: true,
      action: () => { vm.parentCtrl.addItems() },
    },
    {
      title: 'Flytta till',
      action: () => { moveItems(false) },
    },
    {
      btnClass: 'btn--icon btn-fu btn--icon-bin',
      action: () => { recallItems() },
    },
  ];
  vm.actionsApartments = [
    {
      title: 'Flytta till',
      action: () => { moveItems(true) },
    },
  ];

  vm.isNewProduction = type =>
    [NegotiationTypes.NEWLY_CONSTRUCTED_PROPERTY, NegotiationTypes.NEWLY_CONSTRUCTED_APARTMENT].includes(type);

  let getTableau = () => angular.element($document[0].querySelector("#negotiationTableauProperties"));
  let refreshTableau = () => getTableau().scope().$broadcast('refresh');

  $scope.$on('rentListImported', function() {
    refreshTableau();
  });

  Auth.heartbeat().then(function() {
    if (Auth.currentUser().party === Parties.HGF) {
      vm.isHgfUser = true;
    }
  });

  function gotoProperty(item) {
    if (!vm.apartmentMode) {
      $location.search({});
      $location.path('/negotiations/' + $routeParams.id + '/properties/' + item.id);
    }
  }

  vm.parentCtrl.negotiationQueryPromise.then(function() {
    vm.columnsProperties = [
      {
        title: 'Överensstatus',
        column: 'agreementStatus',
        lookup: {
          dictionary: vm.agreementStatuses,
          idProperty: 'id',
          textProperty: 'name',
        },
        ffn: (value, filter) => [value, CommonIds.tableauAllId].includes(filter.id),
      },
      {
        title: 'Fastighetsbeteckning',
        column: 'propertyDesignation'
      },
      {
        title: 'Kommun',
        column: 'municipality'
      },
      {
        title: 'LM distrikt',
        column: 'district'
      },
      {
        title: 'Antal lägenheter',
        column: 'numNegotiatedApartments'
      },
      {
        title: 'Fastighetsägare',
        column: 'owners',
        type: 'array',
      }
    ];

    vm.columnsApartments = [
      {
        title: 'Fastighetsbeteckning',
        column: 'propertyDesignation'
      },
      {
        title: 'Gatuaddress',
        column: 'streetAddress'
      },
      {
        title: 'Nationella lägenhetsnr',
        column: 'nationalNo'
      },
      {
        title: 'Lägenhetsnr',
        column: 'ownerNo'
      },
      {
        title: 'Kommun',
        column: 'municipality'
      },
    ];
  });

  vm.bestandTabs = [
    { title: 'Fastigheter', key: 'properties' },
    { title: 'Lägenheter', key: 'apartments' },
  ];

  /**
   *
   * @param {string} modalSize size css class for modal
   * @param {int} userParty party to edit. 20 for HGF, 0 for FÄ
   */
  function edit(size, userParty) {
    HyUtils.showDefaultModal('EditNegotiationRepresentativesModalCtrl',
      'resources/negotiation/edit/edit-representatives-modal.html', {
        negotiationObject: vm.parentCtrl.negotiation,
        isFreeAgreement: false,
        userParty,
      }, () => {
        $timeout(() => vm.parentCtrl.getNegotiation(), 1200);
      }, null, null, { size }
    );
  }

  function editDelegates() {
    HyUtils.showDefaultModal('EditNegotiationDelegatesModalCtrl',
      'resources/negotiation/edit/edit-delegates-modal.html', {
        negotiationObject: vm.parentCtrl.negotiation,
        isFreeAgreement: false,
      }, () => {
        vm.parentCtrl.getNegotiation();
      });
  }

  function editNegotiation() {
    HyUtils.showDefaultModal('EditNegotiationTypeModalCtrl',
      'resources/negotiation/edit/edit-negotiationType-modal.html', {
        negotiationObject: vm.parentCtrl.negotiation,
        isFreeAgreement: false,
      }, (negotiation) => {
        vm.parentCtrl.negotiation.name = negotiation.name;
        vm.parentCtrl.negotiation.type = negotiation.type;
      });
  }

  vm.fGetProperties = () => {
    // eslint-disable-next-line no-undef
    return new Promise(resolve => {
      let params = {
        id: $routeParams.id,
        include: ['demands', 'owners'],
      };
      let bodyParams = { showInactive: true, getAgreementStatus: true };

      let request = Negotiation.queryProperty(params, bodyParams);

      request.$promise.then(response => { resolve(response) });
    });
  }

  vm.fGetApartments = () => {
    // eslint-disable-next-line no-undef
    return new Promise(resolve => {

      let params = {
        id: $routeParams.id,
        include: ['demands', 'owners'],
      };
      let bodyParams = { };

      let request = Negotiation.queryApartment(params, bodyParams);

      request.$promise.then(response => {
        // eslint-disable-next-line no-undef
        let propertyIds = Array.from(new Set(response.rows.map(row => row.property.id)));
        vm.properties = propertyIds.map(id => response.rows.find(row => row.property.id === id).property.propertyDesignation);

        resolve(response);
      });
    });
  }

  let getSelectedIds = () => vm.selectedRows.map(row => row.id);

  function moveItems(apartmentMode) {
    HyUtils.showDefaultModal('MoveItemsCtrl',
      'resources/negotiation/show/modals/move-items/moveItemsModal.html', {
        itemIds: getSelectedIds(),
        currentNegotiation: vm.parentCtrl.negotiation,
        apartmentMode,
      }, () => {
        refreshTableau();
        vm.parentCtrl.getNegotiation();
      }
    );
  }

  function recallItems() {
    HyUtils.showDefaultModal('RecallItemsCtrl',
      'resources/negotiation/show/modals/recall-items/recallItemsModal.html', {
        itemIds: getSelectedIds(),
        negotiationId: parseInt($routeParams.id),
        apartmentMode: vm.parentCtrl.apartmentMode,
      }, () => {
        refreshTableau();
        vm.parentCtrl.getNegotiation();
      }
    );
  }

  vm.exportRealEstate = () => {
    let sheetData = getTableau().isolateScope().data.map(x => ({
      'Forhandling': vm.parentCtrl.negotiation.caseNumber,
      'Fastighetsbeteckning': x.propertyDesignation,
      'Fastighetsägare': x.owners[0],
      'Antal lägenheter': x.numApartmentsInAgreement,
      'Överensstatus': vm.agreementStatuses[x.agreementStatus].name,
      'Kommun': x.municipality,
      'LM Distrikt': x.district,
    }));

    let buffer = ExportUtils.prettyExcel(sheetData);

    HyUtils.spitOutAttachment(buffer, `Fastighetsbestånd i förhandling ${vm.parentCtrl.negotiation.caseNumber}.xlsx`, 'application/vnd.openxmlformatsofficedocument.spreadsheetml.sheet');
  };

  vm.getContextInfo = row => ({
    title: `Fastighet ${row.propertyDesignation}`,
    link: '/properties/'+row.id,
  });
}

})();